/* eslint-disable react-hooks/exhaustive-deps */
import React, {useMemo} from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { GreenroomState as GS } from '../../stores/types/types';
import {getNameOrInitials} from '../../utils/utils';
import useProfile from '../../hooks/use-profile';

const baseUser = {
	email: '',
	first_name: '',
	last_name: '',
	avatar: '',
	poster: '',
	job_title: '',
	gr_user: 0,
	picture: '',
	title: '',
}

interface Props {
	videoId: string;
	grUserId: number;
	active: boolean;
}

export default function FeedPresenterSafetyPhoto(props: Props) {
	const {videoId, grUserId, active} = props;

	const connectedUsers = useSelector((s: GS) => s.SessionReducer.connectedUsers);
	const user = useSelector((s: GS) => s.SessionReducer.user);
	const invitations = useSelector((s: GS) => s.InvitationsReducer.invitations);

	const {watchedProfile} = useProfile({suggestedProfile: grUserId});
	const maskedProfile = watchedProfile;

	const userFromId = useMemo(() => {
		if (maskedProfile) 
			return {...maskedProfile, poster: maskedProfile.bg_image}

		if (videoId === 'local') 
			return {...user, poster: user?.bg_image};

		const connectedUser = connectedUsers.find((u) => u.gr_user === grUserId);
		if (connectedUser)
			return connectedUser;
		
		const invite = invitations.find((i) => i.profile.gr_user === grUserId);
		if (invite)
			return invite.profile;

		return baseUser;
	}, [grUserId, maskedProfile, videoId])

	const posterImage = useMemo(() => {
		if (userFromId?.poster) return userFromId?.poster;
		if (userFromId?.avatar) return userFromId?.avatar;
		return '';
	}, [maskedProfile?.bg_image, videoId, userFromId?.poster, userFromId?.avatar])

	return <div className={classNames('poster', { active })}>
		{posterImage
			? <img className="poster-image" src={posterImage} alt={''}/>
			: <div className="no-image-placeholder">
				<span style={{backgroundColor: '#333', color: '#FFF'}}>
					{getNameOrInitials(userFromId, false)}
				</span>
			</div>
		}
	</div>
}
